// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__UJ5Fn","heightDiv":"layout_heightDiv__H6c4i"};